import React from 'react';
import PropTypes from 'prop-types';

import { ASC, DESC } from 'constants/sortDirections';
import { InputRadioGroup } from '@companycam/slab-web';
import { translate } from 'translations/i18n';

const SortOrderToggle = ({ setSortOrder, sortOrder }) => {
  const handleOnChange = (event) => {
    setSortOrder(event.target.value);
  };

  return (
    <div>
      <InputRadioGroup
        layout="inline"
        selectedValue={sortOrder}
        id="asset-order-selector"
        label={translate('assetFeed.viewMenu.sortOrderToggle.title')}
        options={[
          {
            label: translate('assetFeed.viewMenu.sortOrderToggle.labelNewest'),
            value: DESC,
            testId: 'view_menu__order-newest',
          },
          {
            label: translate('assetFeed.viewMenu.sortOrderToggle.labelOldest'),
            value: ASC,
            testId: 'view_menu__order-oldest',
          },
        ]}
        onChange={handleOnChange}
      />
    </div>
  );
};

SortOrderToggle.propTypes = {
  setSortOrder: PropTypes.func,
  sortOrder: PropTypes.string,
};

export default SortOrderToggle;
